import moment from 'moment';
import { FC, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { MinaraInfo, UnicaPayInfo } from '../../types';
import { formatUSDNoDecimals } from '../../../../../helpers/helpers';

export const U1AcademyHub: FC<any> = ({ data }: { data: MinaraInfo }) => {
  return (
    <div
      className='d-flex mb-3 mt-2 border border-primary'
      style={{ position: 'relative' }}>
      <img width={200} style={{ marginRight: 20 }} src={data.imageUrl} />
      <div className='flex-column justify-content-between d-flex gap-4'>
        <div className='d-flex'>
          <Col lg={5} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>ORDER ID</h5>
            <h4 className='fs-15 mb-0'>{data.id}</h4>
          </Col>
          <Col lg={5} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>PACKAGE PRICE</h5>
            <h4 className='fs-15 mb-0'>
              {formatUSDNoDecimals(data.price)} USDT/USDC
            </h4>
          </Col>
          <Col lg={5} className='border-end p-3'>
            <h5 className='text-muted text-uppercase fs-13'>
              DATE OF PURCHASE
            </h5>
            <h4 className='fs-15 mb-0'>
              {moment(data?.datePaid).format('DD MMM YYYY')}
            </h4>
          </Col>
        </div>
        <div className='w-100'>
          <h5>Academy Access: {data.name}</h5>
        </div>
      </div>
    </div>
  );
};
